import React, { memo, useState } from 'react';
import AIAssistantDropDown from './AIAssistantDropDown';
import AIAssistantClearChatHistoryModal from './AIAssistantClearChatHistoryModal';

const AIAssistantHeader = ({ hasDropdown, hasHistory, clearHistory }) => {
  const [showClearHistoryConfirmModal, setShowClearHistoryConfirmModal] = useState(false);

  const dropdownOptions = [
    {
      label: 'Clear Chat',
      disabled: !hasHistory,
      onClick: () => setShowClearHistoryConfirmModal(true),
    },
  ];

  return (
    <div className="ai-assistant-header">
      <h4 className="modal-title">AI Assistant</h4>
      {hasDropdown ? <AIAssistantDropDown options={dropdownOptions} /> : null}

      {showClearHistoryConfirmModal ? (
        <AIAssistantClearChatHistoryModal
          onConfirm={() => {
            clearHistory();
            setShowClearHistoryConfirmModal(false)
          }}
          onCancel={() => setShowClearHistoryConfirmModal(false)}
        />
      ) : null}
    </div>
  );
};

export default memo(AIAssistantHeader);
